"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var services_1 = require("stremio/services");
var components_1 = require("../components");
var Info_less_1 = __importDefault(require("./Info.less"));
var Info = function (_a) {
    var _b, _c;
    var streamingServer = _a.streamingServer;
    var shell = (0, services_1.useServices)().shell;
    var t = (0, react_i18next_1.useTranslation)().t;
    var settings = (0, react_1.useMemo)(function () {
        var _a;
        return (((_a = streamingServer === null || streamingServer === void 0 ? void 0 : streamingServer.settings) === null || _a === void 0 ? void 0 : _a.type) === 'Ready' ?
            streamingServer.settings.content : null);
    }, [streamingServer === null || streamingServer === void 0 ? void 0 : streamingServer.settings]);
    return (react_1.default.createElement(components_1.Section, { className: Info_less_1.default['info'] },
        react_1.default.createElement(components_1.Option, { label: t('SETTINGS_APP_VERSION') },
            react_1.default.createElement("div", { className: Info_less_1.default['label'] }, process.env.VERSION)),
        react_1.default.createElement(components_1.Option, { label: t('SETTINGS_BUILD_VERSION') },
            react_1.default.createElement("div", { className: Info_less_1.default['label'] }, process.env.COMMIT_HASH)),
        (settings === null || settings === void 0 ? void 0 : settings.serverVersion) &&
            react_1.default.createElement(components_1.Option, { label: t('SETTINGS_SERVER_VERSION') },
                react_1.default.createElement("div", { className: Info_less_1.default['label'] }, settings.serverVersion)),
        typeof ((_c = (_b = shell === null || shell === void 0 ? void 0 : shell.transport) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.shellVersion) === 'string' &&
            react_1.default.createElement(components_1.Option, { label: t('SETTINGS_SHELL_VERSION') },
                react_1.default.createElement("div", { className: Info_less_1.default['label'] }, shell.transport.props.shellVersion))));
};
exports.default = Info;
